<template lang="pug">
  div.columns.is-vcentered.is-variable.is-4(v-if="horizontal")
    .column.is-narrow
      BField(:label="label")
    .column(v-show="!previewMode || edit")
      .columns.is-mobile.is-variable.is-2
        .column.is-narrow.radio-column
          <!-- @slot Use this slot for first radio input -->
          slot(name="radioOne")
        .column.is-narrow.radio-column
          <!-- @slot Use this slot for second radio input -->
          slot(name="radioTwo")
        .column.is-narrow.radio-column
          <!-- @slot Use this slot for second radio input -->
          slot(name="radioThree")

    // PREVIEW MODE INPUT
    .column.is-narrow(v-show="previewMode && !edit")
      BField
        BInput(v-if="previewMode" :value="previewValue" :readonly="previewMode")
        WtReadonlyInputControls(
          v-if="previewMode"
          :edit="edit"
          @editActive="$event => edit = $event"
        )

  BField(v-else :class="{ 'p-3 has-border-radius-large has-background-light': isFancyRadio }")
    template(slot="label")
      slot(name="label")
        template(v-if="_.isEmpty(labelTooltip)") {{ label }}
        template(v-else)
          WtLabel(
            :text="label"
            :tooltip-text="labelTooltip"
          )
    BField(v-if="previewMode && !edit")
      BInput(:value="previewValue" :readonly="previewMode")
      WtReadonlyInputControls(
        v-if="previewMode"
        :edit="edit"
        @editActive="$event => edit = $event"
      )
    BField(v-else-if="isFancyRadio")
      .radio-one(v-if="$slots['radioOne']" :class="fancyRadioClasses")
        slot(name="radioOne")
        p(v-if="$slots['radioOneText']" :class="fancyRadioTextClasses")
          slot(name="radioOneText")
      .radio-two.ml-2(v-if="$slots['radioTwo']" :class="fancyRadioClasses")
        slot(name="radioTwo")
        p(v-if="$slots['radioTwoText']" :class="fancyRadioTextClasses")
          slot(name="radioTwoText")
      .radio-three.ml-2(v-if="$slots['radioThree']" :class="fancyRadioClasses")
        slot(name="radioThree")
        p(v-if="$slots['radioThreeText']" :class="fancyRadioTextClasses")
          slot(name="radioThreeText")
    BField(v-else)
      slot(name="radioOne")
      slot(name="radioTwo")
      slot(name="radioThree")
</template>

<script>
import WtReadonlyInputControls from "@@/WtReadonlyInputControls/WtReadonlyInputControls";
import WtLabel from "@@/WtLabel/WtLabel";

export default {
  name: "WtRadioQuestionInput",

  components: { WtLabel, WtReadonlyInputControls },

  props: {
    isFancyRadio: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: ""
    },

    labelTooltip: {
      type: String,
      default: ""
    },

    /**
     * positions radio inputs in columns
     */
    horizontal: {
      type: Boolean,
      default: false
    },

    /**
     * enables readonly text based view of selected value,
     * which can be toggled to update value
     */
    previewMode: {
      type: Boolean,
      default: false
    },

    /**
     * text based value to display when in preview mode
     */
    previewValue: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      edit: false,
      fancyRadioClasses: "p-2 has-border-radius-large has-background-white",
      fancyRadioTextClasses: "ml-5 px-2 has-text-grey"
    };
  },

  watch: {
    previewValue: {
      immediate: true,
      handler() {
        this.edit = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.radio-column
  height: 44px
</style>
